<template>
    <div class="loader" :style="'background: #ffffff url('+require('../../../assets/images/ajax-loader-ripple.svg') +') no-repeat scroll center center;display: '+ (isloading ? 'block' : 'none')">
    </div>
</template>
<script>
export default {
    name: 'CallLoader',
    mounted () {
    },
    props: { 
        isloading: { type: Boolean, default: true}
    }
}
</script>
<style scoped>
    .loader{
        height: 80%;
        width: 80%;
        position: absolute;
        z-index: 10;
    }
    .dark-theme .loader{
        background-color: #2f3438 !important;
        opacity: 0.8;
    }
</style>